import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, Toaster } from 'sonner';

interface LoginErrorComponentProps {
  error: Error;
  children?: React.ReactNode;
}

const LoginErrorComponent = ({ error, children }: LoginErrorComponentProps) => {
  const navigate = useNavigate();
  useEffect(() => {
    const errorSummary = error?.message || '';
    if (errorSummary.includes('User is not assigned to the client application')) {
      navigate('/home', { state: { showAuthError: true, error: errorSummary } });
    } else if (errorSummary) {
      toast.error(`Authentication error: ${errorSummary}`, { duration: 5000 });
    }
  }, [error, navigate]);
  return (
    <>
      <Toaster position="top-right" />
      {typeof children === 'function'
        ? (children as (msg: string) => React.ReactNode)(error?.message || 'You are not authorized to access this application.')
        : children}
    </>
  );
};

export default LoginErrorComponent;
